import { requireValue } from "src/utils/require/requireValue";

/**
 * @prettier
 */
export function getUrlDomainSuffix(): string {
    return requireValue(window.location.hostname.match(/[^.]*$/)?.[0]);
}
